export function useObserved() {
  return useNuxtApp().$observed
}
